 import translate from 'utils/apa/translations';
import { getTranslation } from 'utils/getTranslation';

export const ACTIVE = 'ACTIVE';
export const CHANGE = 'CHANGE';
export const DEFAULT = 'DEFAULT';
export const DESACTIVE = 'DESACTIVE';
export const MODIFY = 'MODIFY';
export const NOT_ACTIVE = 'NOT_ACTIVE';
export const SET_PIN = 'SET_PIN';
export const REMIND = 'REMIND';
export const VALID_EMAIL = 'VALID_EMAIL';

export const MODAL_SUCCESS = 'SuccessSimple';
export const MODAL_ERROR = 'ErrorSimple';

export const PIN = 'pin';

export const emptyValidation = translations =>
  getTranslation('profile_empty_field', translations);
export const noMatchValidation = translations =>
  getTranslation('profile_pin_field_no_match', translations) ||
  'No concuerdan.';
export const invalidPin = translations =>
  getTranslation('profile_pin_valid_lenght', translations) ||
  'Debes ingresar un PIN entre 4 y 6 caracteres.';
export const isNotChecked = translations =>
  getTranslation('profile_pin_valid_checked', translations) ||
  'Debes seleccionar una opcion';

export const getMessage = ({ code, message, translations }) => getTranslation(code, translations) || message;

export const getSelectRating = translation => {
  const pg = getTranslation('profile_pin_clasification_label_pg', translation);
  const pg13 = getTranslation(
    'profile_pin_clasification_label_pg13',
    translation,
  );
  const r = getTranslation('profile_pin_clasification_label_r', translation);
  const nc = getTranslation('profile_pin_clasification_label_nc', translation);
  return [
    {
      value: 20,
      text: pg,
    },
    {
      value: 30,
      text: pg13,
    },
    {
      value: 40,
      text: r,
    },
    {
      value: 50,
      text: nc,
    },
  ];
};

export const getLabels = translations => {
  const title = getTranslation('profile_pin_code_title', translations);
  const subTitleNotActive = getTranslation(
    'profile_pin_not_active_description',
    translations,
  );
  const subTitleActive = getTranslation(
    'profile_pin_modify_advice',
    translations,
  );
  const subTitleRemind = getTranslation(
    'profile_pin_code_remind_active',
    translations,
  );
  const subTitleChange = getTranslation(
    'profile_pin_change_description',
    translations,
  );
  const titlePinCode = getTranslation(
    'profile_pin_code_parental_control_title',
    translations,
  );
  const descPinCode = getTranslation(
    'profile_pin_code_parental_control_text',
    translations,
  );
  const titlePayment = getTranslation(
    'profile_pin_code_payment_protection_title',
    translations,
  );
  const descPayment = getTranslation(
    'profile_pin_code_payment_protection_text',
    translations,
  );
  const titleConfirm = getTranslation(
    'profile_pin_confirm_changes',
    translations,
  );
  const descConfirm = getTranslation(
    'profile_pin_confirm_changes_desc',
    translations,
  );
  const titleRemind = getTranslation(
    'profile_pin_code_remind_title',
    translations,
  );
  const descRemind = getTranslation(
    'profile_pin_code_email_send_sub',
    translations,
  );
  const titleDesactive = getTranslation(
    'profile_pin_code_disabled_title',
    translations,
  );
  const descDesactive = getTranslation(
    'profile_pin_code_deactivate_description',
    translations,
  );
  const descPinCodeDefault = getTranslation(
    'profile_pin_code_active_message',
    translations,
  );
  const descPinCodeParetalOff = getTranslation(
    'profile_pin_code_parental_off_message',
    translations,
  );
  const descPaymentDefault = getTranslation(
    'profile_pin_code_purchase_active_message',
    translations,
  );
  const descPinCodePurchaselOff = getTranslation(
    'profile_pin_code_purchase_off_message',
    translations,
  );

  const selectRating = getTranslation(
    'profile_pin_clasification_label',
    translations,
  );
  const inputPin = getTranslation('pay_code_enter_pin', translations);
  const inputCurrentPin = getTranslation(
    'profile_pin_change_input_current',
    translations,
  );
  const inputNewPin = getTranslation(
    'profile_pin_change_input_new',
    translations,
  );
  const inputConfirmPin = getTranslation(
    'profile_pin_input_repeat_placeholder',
    translations,
  );

  const btnActive = getTranslation(
    'profile_pin_modify_activate_label',
    translations,
  );
  const btnDesactive = getTranslation(
    'profile_pin_code_button_disabled',
    translations,
  );
  const btnChange = getTranslation(
    'profile_pin_code_button_change',
    translations,
  );
  const btnRemind = getTranslation('', translations) || 'Recordar PIN';
  const btnModify = getTranslation('', translations) || 'Modificar';
  const btnRemindPin = getTranslation(
    'profile_pin_code_button_send_pin',
    translations,
  );
  const btnConfirm = getTranslation('profile_pin_confirm_button', translations) || 'Confirmar';
  const btnChangePin = getTranslation(
    'profile_pin_button_change_pin',
    translations,
  );
  const btnCancel = getTranslation('profile_button_cancel', translations);

  const placeholder = getTranslation(
    'control_pin_input_placeholder_pin',
    translations,
  );

  return {
    default: {
      title,
      controlPin: {
        title: titlePinCode,
        description: descPinCodeDefault,
        descriptionOff: descPinCodeParetalOff,
      },
      paymentProtection: {
        title: titlePayment,
        description: descPaymentDefault,
        descriptionOff: descPinCodePurchaselOff,
      },
    },
    notActive: {
      title,
      subTitle: subTitleNotActive,
      controlPin: {
        title: titlePinCode,
        description: descPinCode,
      },
      paymentProtection: {
        title: titlePayment,
        description: descPayment,
      },
    },
    active: {
      title,
      subTitle: subTitleActive,
      controlPin: {
        title: titlePinCode,
        description: descPinCode,
      },
      paymentProtection: {
        title: titlePayment,
        description: descPayment,
      },
      confirm: {
        title: titleConfirm,
        description: descConfirm,
      },
      input: {
        text1: inputPin,
        check: btnActive,
        select: selectRating,
        placeholder,
      },
    },
    remind: {
      title,
      subTitle: subTitleRemind,
      remember: {
        title: titleRemind,
        description: descRemind,
      },
    },
    change: {
      title,
      subTitle: subTitleChange,
      input: {
        currentPin: inputCurrentPin,
        newPin: inputNewPin,
        confirmPin: inputConfirmPin,
        placeholder,
      },
    },
    desactive: {
      title,
      subTitle: subTitleRemind,
      input: {
        text1: inputPin,
        placeholder,
      },
      desactive: {
        title: titleDesactive,
        description: descDesactive,
      },
    },
    btn: {
      btnActive,
      btnDesactive,
      btnChange,
      btnRemind,
      btnModify,
      btnConfirm,
      btnChangePin,
      btnRemindPin,
      btnCancel,
    },
  };
};
